import React from "react";
import styled from "styled-components/macro";
import {
  Grid,
  List,
  ListItemText as MuiListItemText,
  ListItem as MuiListItem,
  Button,
} from "@material-ui/core";
import TranslateIcon from "@material-ui/icons/Translate"; // Language Icon
import { useTranslation } from "react-i18next";
import { changeAndPersistLanguage } from "../services/localizationService";

const Wrapper = styled.div`
  padding: ${(props) => props.theme.spacing(1) / 4}px
    ${(props) => props.theme.spacing(4)}px;
  background: ${(props) => props.theme.footer.background};
  position: relative;
`;

const ListItem = styled(MuiListItem)`
  display: inline-block;
  width: auto;
  padding-left: ${(props) => props.theme.spacing(2)}px;
  padding-right: ${(props) => props.theme.spacing(2)}px;
  &,
  &:hover,
  &:active {
    color: #ff0000;
  }
`;

const ListItemText = styled(MuiListItemText)`
  span {
    color: ${(props) => props.theme.footer.color};
  }
`;

const LanguageIconWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const LanguageButton = styled(Button)`
  color: ${(props) =>
    props.$active ? props.theme.palette.primary.main : "#888"};
  border: ${(props) =>
    props.$active ? `2px solid ${props.theme.palette.primary.main}` : "none"};
  font-size: 0.8rem;
  padding: 4px 8px;
  min-width: auto;
  height: auto;
`;

function Footer() {
  const { t, i18n } = useTranslation(); // useTranslation hook
  const currentLang = i18n.language; // Current language

  const handleLanguageChange = (lang) => {
    changeAndPersistLanguage(lang);
  };

  return (
    <Wrapper>
      <Grid container spacing={0}>
        <Grid
          container
          item
          xs={6}
          md={4}
          justifyContent="flex-start"
          alignItems="center"
        >
          <List>
            <ListItem button={true} component="a" href="#">
              <ListItemText primary={t("Soporte")} />
            </ListItem>
            <ListItem button={true} component="a" href="/document/center">
              <ListItemText primary={t("Centro de documentación")} />
            </ListItem>
          </List>
        </Grid>

        <Grid
          container
          item
          xs={6}
          md={4}
          justifyContent="center"
          alignItems="center"
        >
          <List>
            <ListItem button={true}>
              <ListItemText
                primary={`© ${new Date().getFullYear()} - WifiAds Media Networks`}
              />
            </ListItem>
          </List>
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={4}
          justifyContent="center"
          alignItems="center"
        >
          {/* Language Switcher */}
          <LanguageIconWrapper>
            <TranslateIcon style={{ color: "#888" }} />
            <LanguageButton
              $active={currentLang === "en"}
              onClick={() => handleLanguageChange("en")}
            >
              EN
            </LanguageButton>
            <LanguageButton
              $active={currentLang === "es"}
              onClick={() => handleLanguageChange("es")}
            >
              ES
            </LanguageButton>
          </LanguageIconWrapper>
        </Grid>
      </Grid>
    </Wrapper>
  );
}

export default Footer;
